import { getUserId } from '../../../../DefaultService';
import { IPaginationParams } from '../../../../types';
import { queryClient } from 'index';
import { ILprEventSimpleProps } from '../../types';

export const LPR_EVENTS_CACHE_KEY = 'lprEvent';

const USER_ID = getUserId();

export const useLprEventDataStreamCache = () => {
  return {
    getCacheData: (pagination: IPaginationParams): any[] | undefined =>
      queryClient.getQueryData<ILprEventSimpleProps[]>([
        `${LPR_EVENTS_CACHE_KEY}${pagination.pageNumber}`,
        pagination,
        USER_ID,
      ]),
    setCacheData: (
      data: ILprEventSimpleProps[],
      pagination: IPaginationParams,
    ) =>
      queryClient.setQueryData(
        [
          `${LPR_EVENTS_CACHE_KEY}${pagination.pageNumber}`,
          pagination,
          USER_ID,
        ],
        data,
      ),
    clearCacheData: () => {
      queryClient
        .getQueryCache()
        .getAll()
        .forEach(({ queryKey }) => {
          if (
            Array.isArray(queryKey) &&
            queryKey[0].startsWith(LPR_EVENTS_CACHE_KEY) &&
            queryKey[2] == USER_ID
          ) {
            queryClient.removeQueries({ queryKey });
          }
        });
    },
  };
};
